export enum SurveyStatusEnum {
  Draft = 'draft',
  Active = 'active',
  Paused = 'paused',
  Finished = 'finished',
}

export const SurveyStatusEnumLabels: Record<SurveyStatusEnum, string> = {
  [SurveyStatusEnum.Draft]: 'Borrador',
  [SurveyStatusEnum.Active]: 'Activa',
  [SurveyStatusEnum.Paused]: 'Pausada',
  [SurveyStatusEnum.Finished]: 'Finalizada',
};
